/* global __webpack_public_path__ */
// Runtime app settings: fetched from this app's CDN once, cached in memory, off the MF runtime path.

let cache = null;

/** Cached app settings, or {} before loadAppSettings() resolves. */
export function getAppSettings() {
  return cache || {};
}

/** Test/host seam: set the cache; pass null to force a refetch. */
export function setAppSettings(value) {
  cache = value;
}

/** Fetch + cache appsettings.json once; fails soft to {} with cache left null to retry. */
export async function loadAppSettings() {
  if (cache) return cache;

  let baseUrl = (typeof __webpack_public_path__ !== 'undefined' && __webpack_public_path__) || '/';
  if (!baseUrl.endsWith('/')) baseUrl += '/';

  try {
    const response = await fetch(`${baseUrl}appsettings.json`, { cache: 'no-store' });
    if (!response.ok) throw new Error(`appsettings.json ${response.status}`);
    const data = await response.json();
    if (!data || typeof data !== 'object' || Array.isArray(data)) {
      throw new Error('appsettings.json is not a JSON object');
    }
    cache = data;
  } catch (error) {
    console.error('[transportation-network-ui] failed to load appsettings.json', error);
    return {}; // leave cache null so the next mount retries
  }
  return cache;
}
